import api from '@pray/shared/utils/api';

import type { CloneTemplateResponse } from './data/response';
import type { CloneTemplateRequest } from './data/types';

type CloneTemplateProps = {
  artistId: string;
  templateId: string;
  data: CloneTemplateRequest;
};

export async function cloneTemplate({
  artistId,
  templateId,
  data,
}: CloneTemplateProps): Promise<CloneTemplateResponse> {
  if (!artistId) throw new Error('Artist ID is required');
  if (!templateId) throw new Error('Template ID is required');
  if (!data.name) throw new Error('Workflow name is required');

  const url = `/web/studio/artists/${artistId}/workflows/templates/${templateId}/clone`;

  const response = await api.executePostRequest<CloneTemplateResponse>(url, data);
  return response.data;
}
